import { v4 as uuidv4 } from 'uuid';
import { LabelPrintScenarioItemsPluginSettings } from './LabelPrintScenarioItemsPluginSettings';
import { LabelPrintScenarioItemsPluginView } from './LabelPrintScenarioItemsPluginView';

export const LabelPrintScenarioItemsTab = (): ITab => {
    return {
        id: uuidv4(),
        title: 'Позиции',
        view: {
            content: LabelPrintScenarioItemsPluginSettings
                ? <LabelPrintScenarioItemsPluginView />
                : <p> Справочник не настроен</p>
        }
    }
}
